<ngx-ui-loader></ngx-ui-loader>

<div [@routeAnimations]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet">
  </router-outlet>
</div>